import { render, staticRenderFns } from "./Calc.vue?vue&type=template&id=28b10590&scoped=true"
import script from "./Calc.vue?vue&type=script&lang=ts"
export * from "./Calc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b10590",
  null
  
)

export default component.exports